import { all, call, delay, select, takeEvery } from 'redux-saga/effects';
import { apiRequestSuccess } from 'services/api/api.actions';
import { createIsApiActionOf } from 'services/api/api.helpers';
import { dynamicNavbarContentEndpointResourceId } from './cmsContent.config';
import { prefetchSlideInMenuImages } from './cmsContent.helpers';
import { selectNavbarContent } from './cmsContent.selectors';
import { NavbarContent } from './cmsContent.types';

export function* handleNavbarLoaded(
  action: ReturnType<typeof apiRequestSuccess>,
) {
  const navbarContent: NavbarContent = yield select(selectNavbarContent);

  yield delay(200);
  yield call(prefetchSlideInMenuImages, navbarContent.menuTab);
}

export default function* rootCmsContentSaga() {
  yield all([
    takeEvery(
      createIsApiActionOf(
        apiRequestSuccess,
        dynamicNavbarContentEndpointResourceId,
      ),
      handleNavbarLoaded,
    ),
  ]);
}
